import React, { FC } from 'react'
import {
  Grid,
  Theme,
  Typography,
  makeStyles,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Box
} from '@material-ui/core'

export const AboutModal: FC = () => {
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper} square elevation={0}>
        <Grid container>
          <Grid item sm={4}>
            <Typography variant='h5' component='h3'>
              About the event
            </Typography>
            <div className={classes.redLine} />
          </Grid>

          <Grid item sm={8}>
            <Typography paragraph>
              Public Safety agencies are looking for ways to become more agile with 5G to better support First
              Responders and their communities.
            </Typography>

            <Typography paragraph>
              During this hour-long event, Verizon will explain why 5G matters to First Responders today and in the
              future. The discussion will include new technology solutions and public safety-focused use cases.
            </Typography>
          </Grid>
        </Grid>
        <Grid container className={classes.eventAgendaContainer}>
          <Grid item xs={12} sm={4}>
            <Typography variant='h5' component='h3'>
              Event agenda
            </Typography>

            <div className={classes.redLine} />
            <Typography paragraph className={classes.eventDate}>
              June 10, 2021
              <br />
              2&nbsp;&nbsp;PM EDT
            </Typography>
            <Typography
              component='a'
              variant='h6'
              className={classes.bios}
              href='https://enterprise.verizon.com/resources/events/6-10-public-sector-5g-innovation-session/'
              target='_blank'
            >
              View speaker bios here
            </Typography>
          </Grid>

          <Grid item xs={12} sm={8}>
            <Table className={classes.table}>
              <TableBody>
                <TableRow>
                  <TableCell>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5}>
                        <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                          Verizon’s commitment to 5G
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Typography paragraph className={classes.presenter}>
                          Tami Erwin - CEO, Verizon Business
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5}>
                        <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                          Verizon Public Sector: Your indispensable partner in 5G
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Typography paragraph className={classes.presenter}>
                          Jennifer Chronis - Senior Vice President, Public Sector, Verizon
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5}>
                        <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                          Verizon Frontline: What it is and how it will benefit Public Safety
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Typography paragraph className={classes.presenter}>
                          Patty Roze - Vice President, Public Sector, Verizon
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5}>
                        <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                          What 5G technologies can do for Public Safety
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Typography paragraph className={classes.presenter}>
                          Mike Haberman - Vice President, Technology Development &amp; Planning, Verizon
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ borderBottom: 0 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5}>
                        <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                          How Verizon Frontline and 5G can transform Public Safety for communities
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                          Sanyogita Shamsunder (moderator) - Vice President, Product Strategy &amp; Operations, Verizon
                        </Typography>
                        <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                          Marshall Freeman - Chief Operating Officer, Atlanta Police Foundation
                        </Typography>
                        <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                          Dr. Walt Magnussen - Director, Internet 2 Technology Evaluation Center, Texas A&amp;M
                        </Typography>
                        <Typography paragraph className={`${classes.presenter} ${classes.multiPresenter}`}>
                          Dr. Jerome Hauer - Former Commissioner, New York State Division of Homeland Security and
                          Emergency Services & Former Acting Assistant Secretary, Office of Public Health Emergency
                          Preparedness, U.S. Department of Health and Human Services
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={5}>
                        <Typography variant='h6' component='h6' className={classes.agendaItemTitle}>
                          Closing remarks
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={7}>
                        <Typography paragraph className={classes.presenter}>
                          Vickie Lonker - Vice President, Public Sector Solutions, Verizon
                        </Typography>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxHeight: '96vh',
    height: '96vh',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  paper: {
    padding: theme.spacing(8, 10),
    position: 'relative',
    width: '100%',
    paddingBottom: '100px',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 4)
    },
    [theme.breakpoints.down('xs')]: {
      padding: '2rem',
      marginBottom: 100
    }
  },
  eventAgendaContainer: {
    marginTop: theme.spacing(6)
  },
  introContainer: {
    marginTop: 13
  },
  agendaItemTitle: {
    fontSize: 18,
    marginBottom: 7,
    lineHeight: '16.8px'
  },
  presenter: {
    fontSize: 16,
    lineHeight: '19.15px',
    marginBottom: 10
  },
  multiPresenter: {
    marginBottom: 4
  },
  eventDate: {
    marginTop: 16
  },
  itemDetails: {
    fontSize: 14,
    lineHeight: '16.76px'
  },
  sectionTitle: {
    fontSize: 28,
    '&:after': {}
  },
  redLine: {
    backgroundColor: theme.palette.VZRed.main,
    height: 4,
    margin: '1.25rem 0',
    width: 32
  },
  bios: {
    fontSize: 14,
    color: 'black',
    fontFamily: 'Verizon-Regular',
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16,
      display: 'block'
    }
  },
  table: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      paddingLeft: 0
    }
  },
  tableSchedule: {
    minWidth: 210,
    verticalAlign: 'top'
  }
}))
